import { createContext, useContext } from 'react';

const DisclosurePopupContext = /*#__PURE__*/createContext({});
const DisclosurePopupProvider = DisclosurePopupContext.Provider;
const useDisclosurePopupContext = () => {
  return useContext(DisclosurePopupContext);
};

export { DisclosurePopupProvider, useDisclosurePopupContext };
